export default __webpack_public_path__ + "static/media/circle.3c5443cd.svg";